import {
  IconDashboard,
  IconKey,
  IconListDetails,
  IconPlayerPlay,
  IconSettings,
  IconShieldLock,
} from '@tabler/icons-react'
import { ArchbaseNavigationItem } from '@archbase/admin'

import { HomeView } from '@views/home/HomeView'
import { KeysView } from '@views/keys/KeysView'
import { JobsView } from '@views/jobs/JobsView'
import { PlaygroundView } from '@views/playground/PlaygroundView'
import { SettingsView } from '@views/settings/SettingsView'
import { AuditView } from '@views/audit/AuditView'

import {
  HOME_ROUTE,
  KEYS_ROUTE,
  JOBS_ROUTE,
  PLAYGROUND_ROUTE,
  SETTINGS_ROUTE,
  AUDIT_ROUTE,
} from './navigationDataConstants'

const rootRoute: ArchbaseNavigationItem = {
  label: 'Início',
  icon: <IconDashboard />,
  link: '/',
  category: 'home',
  color: '#339af0',
  component: <HomeView />,
  showInSidebar: false,
  keepAlive: true,
}

const dashboardRoute: ArchbaseNavigationItem = {
  label: 'Visão geral',
  icon: <IconDashboard />,
  link: HOME_ROUTE,
  category: 'dashboard',
  color: '#339af0',
  component: <HomeView />,
  showInSidebar: true,
  keepAlive: true,
}

const keysRoute: ArchbaseNavigationItem = {
  label: 'Chaves de API',
  icon: <IconKey />,
  link: KEYS_ROUTE,
  category: 'admin',
  color: '#7950f2',
  component: <KeysView />,
  showInSidebar: true,
  keepAlive: true,
}

const jobsRoute: ArchbaseNavigationItem = {
  label: 'Jobs',
  icon: <IconListDetails />,
  link: JOBS_ROUTE,
  category: 'monitor',
  color: '#20c997',
  component: <JobsView />,
  showInSidebar: true,
  keepAlive: true,
}

const playgroundRoute: ArchbaseNavigationItem = {
  label: 'Playground',
  icon: <IconPlayerPlay />,
  link: PLAYGROUND_ROUTE,
  category: 'tools',
  color: '#fd7e14',
  component: <PlaygroundView />,
  showInSidebar: true,
  keepAlive: false,
}

const settingsRoute: ArchbaseNavigationItem = {
  label: 'Configurações',
  icon: <IconSettings />,
  link: SETTINGS_ROUTE,
  category: 'admin',
  color: '#7950f2',
  component: <SettingsView />,
  showInSidebar: true,
  keepAlive: false,
}

const auditRoute: ArchbaseNavigationItem = {
  label: 'Auditoria',
  icon: <IconShieldLock />,
  link: AUDIT_ROUTE,
  category: 'admin',
  color: '#7950f2',
  component: <AuditView />,
  showInSidebar: true,
  keepAlive: false,
}

export const navigationData: ArchbaseNavigationItem[] = [
  rootRoute,
  dashboardRoute,
  keysRoute,
  settingsRoute,
  auditRoute,
  jobsRoute,
  playgroundRoute,
]
